import { useAuth0 } from '@auth0/auth0-react';
import { notification } from 'antd';
import Router from 'next/router';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Container from '@/src/shared/components/Container';
import Section from '@/src/shared/components/Section';
import request from '@/utils/axios';

const StatenetRedirect = props => {
  const { isLoggedIn, personId, emailaddress, type } = props;
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  const redirectMember = async (id, email) => {
    if (!id || !email) return;
    await request({
      url: '/lookup/statenetredirecturl',
      params: {
        personId: Number(id),
        email,
        type,
      },
    }).then(response => {
      const { data } = response;
      if (data) {
        window.location = data;
      }

      if (!data) {
        notification.error({
          message: 'Error',
          description: data.Message,
        });
      }
    });
  };

  useEffect(() => {
    if (isLoggedIn && type) {
      redirectMember(personId, emailaddress);
    }

    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [type, personId, emailaddress, isLoading, isAuthenticated]);

  return (
    <>
      <Section>
        <Container>
          <h2>Redirecting to LexisNexis State Net...</h2>
        </Container>
      </Section>
    </>
  );
};

export const getStaticProps = async ({ params }) => {
  return {
    props: {
      type: params.slug,
    },
  };
};

export async function getStaticPaths() {
  return {
    paths: [{ params: { slug: 'maptrack' } }, { params: { slug: 'profile' } }],
    fallback: false,
  };
}

export default connect(
  state => {
    const { auth } = state;
    const {
      isLoggedIn,
      userinfo: { PersonID, emailaddress },
    } = auth;
    return {
      isLoggedIn,
      personId: PersonID,
      emailaddress,
    };
  },
  null
)(StatenetRedirect);
